function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _dec, _dec2, _class, _class2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

import { Brick } from "zengular";
import twig from "./comment-stream.twig";
import "./comment-stream.scss";
import replyTwig from "./comment-stream.reply.twig";
import { slideDown, slideUp, slideStop, isVisible } from 'slide-anim';
import service from "../../modules/services/services";
import emojione from "emojione";
import Alert from "../../modals/alert.brick";
emojione.ascii = true;
var CommentStreamBrick = (_dec = Brick.register('comment-stream', twig), _dec2 = Brick.listen('respo-change'), _dec(_class = (_class2 = /*#__PURE__*/function (_Brick) {
  _inherits(CommentStreamBrick, _Brick);

  var _super = _createSuper(CommentStreamBrick);

  function CommentStreamBrick() {
    _classCallCheck(this, CommentStreamBrick);

    return _super.apply(this, arguments);
  }

  _createClass(CommentStreamBrick, [{
    key: "setPage",
    value: function setPage(page) {
      this.page = page;
      this.render(page);
    }
  }, {
    key: "onInitialize",
    value: function onInitialize() {
      this.user = service.User.current;
      this.streamId = this.dataset.id;
      this.stream = null;
      this.comments = [];
      this.page = 1;
      this.count = 0;
      this.selfModerateTimeout = service.SiteData.config['self-moderate-timeout'];
    }
  }, {
    key: "beforeRender",
    value: function beforeRender() {
      var _this = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      return service.Comment.getStream(this.streamId, page).then(function (xhr) {
        _this.comments = xhr.response.comments;
        _this.stream = xhr.response.stream;
      });
    }
  }, {
    key: "createViewModel",
    value: function createViewModel() {
      var _this2 = this;

      return {
        user: this.user,
        stream: this.stream,
        page: this.page,
        comments: this.comments.map(function (item) {
          item.hexid = item.id.toString(36).padStart(5, '0');
          item.message = _this2.parseMessage(item.message);
          var age = parseInt(item.age);

          if (item.age > -1 && _this2.selfModerateTimeout - age > 0) {
            item.selfModerateTimeout = (Math.floor(Date.now() / 1000) + _this2.selfModerateTimeout - age) * 1000;
          }

          return item;
        }),
        respo: this.root.getAttribute('respo'),
        pagerSize: 11
      };
    }
  }, {
    key: "onRender",
    value: function onRender() {
      var _this3 = this;

      this.$$('send').listen('click', function () {
        return _this3.send('visitor', _this3.$$('message-text').node.value, _this3.$$('reply-to').node.dataset.replyTo);
      });
      this.$$('send-as-moderator').listen('click', function () {
        return _this3.send('moderator', _this3.$$('message-text').node.value, _this3.$$('reply-to').node.dataset.replyTo);
      });
      this.$$('clear-reply').listen('click', function () {
        return _this3.clearReply();
      });
      this.addCommentEventListeners(this.root);
      this.getLinkImages();
      this.$$('pager').each(function (pager) {
        pager.controller.render({
          pages: Math.ceil(_this3.stream.count / _this3.stream.pageSize),
          page: _this3.page,
          callback: function callback(page) {
            return _this3.setPage(page);
          }
        });
      });
      this.updateSelfModerateMarker();
    }
  }, {
    key: "updateSelfModerateMarker",
    value: function updateSelfModerateMarker() {
      var _this4 = this;

      setTimeout(function () {
        _this4.$('div.self-moderate-marker').each(function (node) {
          var time = Date.now();

          if (time > node.dataset.selfModerateTimeout) {
            node.parentElement.querySelector('.btn.self-moderate').remove();
            node.remove();
          } else {
            node.style.setProperty('--width', 100 - (node.dataset.selfModerateTimeout - time) / (_this4.selfModerateTimeout * 1000) * 100 + '%');
          }
        });

        if (_this4.$('div.self-moderate-marker').node !== null) _this4.updateSelfModerateMarker();
      }, 20);
    }
  }, {
    key: "addCommentEventListeners",
    value: function addCommentEventListeners(root) {
      var _this5 = this;

      this.$$('show-previous').scope(root).listen('click', function (event, target) {
        return _this5.loadPrevious(target);
      });
      this.$$('reply').scope(root).listen('click', function (event, target) {
        return _this5.reply(target.dataset.nick, target.dataset.commentId);
      });
      this.$$('hide').scope(root).listen('click', function (event, target) {
        return _this5.moderate('hide', target.dataset.commentId);
      });
      this.$$('show').scope(root).listen('click', function (event, target) {
        return _this5.moderate('show', target.dataset.commentId);
      });
      this.$$('self-moderate').scope(root).listen('click', function (event, target) {
        return _this5.selfModerate(target.dataset.commentId);
      });
    }
  }, {
    key: "clearReply",
    value: function clearReply() {
      this.$$('reply-to').filter(' strong').node.innerHTML = '';
      this.$$('reply-to').node.dataset.replyTo = '';
      this.$$('reply-to').node.style.display = 'none';
    }
  }, {
    key: "reply",
    value: function reply(nick, commentId) {
      this.$$('reply-to').filter(' strong').node.innerHTML = nick;
      this.$$('reply-to').node.dataset.replyTo = commentId;
      this.$$('reply-to').node.style.display = 'block';
      window.location.href = "#write-comment";
    }
  }, {
    key: "send",
    value: function send(sendAs, text, replyId) {
      var _this6 = this;

      text = emojione.toShort(emojione.shortnameToUnicode(text)).trim();

      if (text.length < 3) {
        Alert.modalify({
          title: 'Komment',
          content: 'A hozzászólás legyen legalább 3 karakter!',
          icon: "fas fa-exclamation-circle"
        }).then(function (window) {
          return window.shake();
        });
        return;
      }

      return service.Comment.send(this.streamId, replyId, sendAs, text).then(function (xhr) {
        return _this6.setPage(1);
      });
    }
  }, {
    key: "moderate",
    value: function moderate(mode, commentId) {
      var _this7 = this;

      return service.Comment.moderate(this.streamId, commentId, mode).then(function (xhr) {
        return _this7.render();
      });
    }
  }, {
    key: "loadPrevious",
    value: function loadPrevious(target) {
      var _this8 = this;

      if (target.dataset.handled !== 'yes') {
        target.dataset.handled = 'yes';
        service.Comment.get(this.streamId, target.dataset.replyId).then(function (xhr) {
          var reply = Object.assign({}, xhr.response);
          reply.message = _this8.parseMessage(reply.message);

          var comment = _this8.renderSubTemplate(replyTwig, reply);

          target.closest('div.stack').appendChild(comment);

          _this8.addCommentEventListeners(comment);

          slideUp(target);
          slideDown(comment).then(function () {
            return slideDown(comment.querySelector('.avatar'));
          }).then(function () {
            return _this8.getLinkImages();
          });
        });
      }
    }
  }, {
    key: "renderSubTemplate",
    value: function renderSubTemplate(twig, data) {
      var template = document.createElement('template');
      template.innerHTML = twig(data);
      return template.content.cloneNode(true).childNodes[0];
    }
  }, {
    key: "selfModerate",
    value: function selfModerate(id) {
      var _this9 = this;

      return service.Comment.selfModerate(this.streamId, id).then(function (xhr) {
        return _this9.render();
      });
    }
  }, {
    key: "respochange",
    value: function respochange(event) {
      this.root.setAttribute('respo', event.data.view);
    }
  }, {
    key: "parseMessage",
    value: function parseMessage(message) {
      message = emojione.shortnameToUnicode(message);
      message = message.replace(/\(\(([\s\S]*?)\)\)/gm, '<label><i class="fad fa-eye"></i> <input class="spoiler" type="checkbox"><span>$1</span></label>');
      var youtube = /(?:https?:\/\/)?(?:www\.)?(?:m\.)?(?:youtube\.com\/\S*(?:(?:\/e(?:mbed))?\/|watch\?(?:\S*?&?v\=))|youtu\.be\/)([a-zA-Z0-9_-]{6,11})([^\s-]*)/gm;
      message = message.replace(youtube, '@(youtube:$1)');
      var link = /((?:www\.|http:\/\/|https:\/\/)+([^\s\/]*)[^\s]*)/gm;
      message = message.replace(link, ' <a class="message-link" href="$1" target="_blank">$2</a> ');
      var youtubelink = /@\(youtube:(.*?)\)/;
      message = message.replace(youtubelink, '<div class="video-container">' + '<iframe src="https://www.youtube.com/embed/$1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>' + '</div>');
      message = message.replace(/[\n]{3,}/gm, '\n\n');
      message = message.replace(/\n/gm, '<br>');
      return message;
    }
  }, {
    key: "getLinkImages",
    value: function getLinkImages() {
      this.$('.message-link:not(.not-image)').each(function (node) {
        var href = node.getAttribute('href');

        if (href.toLowerCase().endsWith('jpg') || href.endsWith('jpeg') || href.endsWith('png') || href.endsWith('gif')) {
          var xhr = new XMLHttpRequest();
          xhr.open("HEAD", href, true); // Notice "HEAD" instead of "GET",
          //  to get only the header

          xhr.onreadystatechange = function () {
            if (xhr.readyState === xhr.DONE) {
              var size = parseInt(xhr.getResponseHeader("Content-Length"));

              if (size < 512 * 1024) {
                var image = document.createElement('img');
                image.classList.add('message-image');
                image.src = href;
                node.parentNode.replaceChild(image, node);
              } else {
                node.classList.add('not-image');
              }
            }
          };

          xhr.send();
        } else {
          node.classList.add('not-image');
        }
      });
    }
  }]);

  return CommentStreamBrick;
}(Brick), (_applyDecoratedDescriptor(_class2.prototype, "respochange", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "respochange"), _class2.prototype)), _class2)) || _class);
export { CommentStreamBrick as default };